// If any import references a json file it scerws up auto import
// Don't put anything else in here
import App from './applications-app.config.json';
export const ApplicationsAppConfig = App.App;
